<template>
  <ValidationProvider ref="vm" :name="name" :rules="rules" v-slot="{ errors }" :vid="vid">
    <input type="hidden" v-model="input">
    <small v-if="type=='alert'" :id="keyName||name" class="text-danger" v-show="errors[0]">{{message||errors[0]}}</small>
    <small v-else class="label_error" :id="keyName||name" v-show="errors[0]">{{message||errors[0]}}</small>
    
    <!-- info -->
    <small class="label_info" :id="name+'count'" style="display:none"></small>
    <small class="label_warn" :id="name+'count-err'" style="display:none">The number of characters exceeds the recommended limit</small>
  </ValidationProvider>
</template>

<script>
import Gen from '@/libs/Gen'

export default {
  props:{
    name: String,
    keyName: String,
    rules: [String,Object],
    vid: String,
    value: [String,Number,Boolean,Array,Object,Date],
    message: String,
    type: {type:String,default:()=>('label')}
  },
  data(){
    return {
      input: null
    }
  },
  methods: {
    validate(){
      return this.$refs.vm.validate()
    }
  },
  mounted(){
    this.input = this.value
  },
  watch:{
    value(v){
      this.input = v
      Gen.delay(()=>{
        this.$refs.vm.validate()
      }, 50)
    }
  }
}
</script>

<style>
.label_error {
  color: red;
  font-size:12px
}
</style>